import { Rule } from "antd/es/form";
import { useMemo } from "react";

export const useTextFieldRules = () => {
  const longTextRules: Rule[] = useMemo(
    () => [
      {
        max: 2000,
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );

  const titleRules = useMemo(
    () => [
      {
        max: 100,
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );

  const fullNameRules = useMemo(
    () => [
      {
        max: 150,
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );

  return { longTextRules, titleRules, fullNameRules };
};
